export default "__VITE_ASSET__COkVRgWz__"